import React from 'react'
import Common_recharge_page_banner from '../../common_components/common_banner/common_recharge_page_banner/Common_recharge_page_banner'
import My_team_details_cards_section from './my_team_details_cards_section/My_team_details_cards_section'

function My_team_details() {
    return (
        <>
            <section className='My_team_details upgraded_menu_sections'>
                <div className="container">

                    <Common_recharge_page_banner title="My Team Details" className="Upgraded_menu_banner" />
                    <div className="row justify-content-center">
                        <div className="col-lg-7 col-md-10">
                            <div className="profile_tabs_and_content">
                                <div className="section_holder">
                                    <My_team_details_cards_section />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}

export default My_team_details